(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('EquipeCommercialeManagementDialogController',EquipeCommercialeManagementDialogController);

    EquipeCommercialeManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'EquipeCommerciale', 'User', 'Division', 'Collectivity'];

    function EquipeCommercialeManagementDialogController ($stateParams, $uibModalInstance, entity, EquipeCommerciale, User, Division) {
        var vm = this;

        vm.editForm;
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.ec = entity;
        vm.getDgs = getDgs;

        vm.divisionsNoResults = false;
        vm.getDivisions = getDivisions;


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        function getDgs(q, dgNum) {
            return User.search({ query: q }).$promise.then(function (dgs) {
                var noResultName = 'dgsNoResults' + dgNum;
                vm[noResultName] = dgs.length === 0;
                return dgs;
            });
        }


        function save () {
            vm.isSaving = true;
            if (vm.ec.dgs) {
                vm.ec.dgs = vm.ec.dgs.filter(function(u) {
                    return u !== null;
                });
            }
            if (vm.ec.commerciaux) {
                vm.ec.commerciaux = vm.ec.commerciaux.filter(function(u) {
                    return u !== null;
                });
            }

            if (vm.ec && vm.ec.id) {
                EquipeCommerciale.update(vm.ec, onSaveSuccess, onSaveError);
            } else {
                EquipeCommerciale.save(vm.ec, onSaveSuccess, onSaveError);
            }
        }

        function getDivisions(q) {
            return Division.search({ query: q }).$promise.then(function(divisions) {
                vm.divisionsNoResults = divisions.length === 0;
                vm.editForm.division.$setValidity('exist',  divisions.length !== 0);
                return divisions;
            });
        }
    }
})();
